























import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend,
} from 'ramda'
import dayjs from 'dayjs'
// import { vueVimeoPlayer } from 'vue-vimeo-player'
import {
  getModule,
} from 'vuex-module-decorators'
import { DisplaySlideType, DisplayBoardType, SlideDetailsType } from '../../types'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'

// Filter Functions

@Component({
  components: {
  },
})

export default class AllBoards<T extends Vue> extends Mixins(MainMixin) {
  @Prop() data!: DisplayBoardType[]

  @Prop() landscape!: boolean

  @Prop() type!: string

  @Emit()
  makeactive (board: DisplayBoardType) {
    console.log('asdf making active: ', board)
    return board
  }

  @Emit()
  display (x: string, y: string) {
    return [x, y]
  }

  detailsMap = {
    scheduleStartDate: false,
    scheduleEndDate: false,
  }

  firstImage (board: DisplayBoardType) {
    if (board.slides.length === 0 || !board.slides[0]) {
      return null
    } return `https://firebasestorage.googleapis.com/v0/b/canvas-displays/o/${this.group}%2Fslides%2F${board.slides[0]}_200x200.png?alt=media`
  }
}
